export default __webpack_public_path__ + "static/media/T165_SOV.e39cbea0.pdf";